import playlistApi from '@/services/playlistApi'
import _ from 'lodash'
import { mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      playlist_data: (state) => state.playlist.playlist,
    }),
  },
  methods: {
    ...mapMutations('playlist', ['UPDATE_PLAYLIST', 'UPDATE_PLAYLIST_VIDEOS']),
    checkPlaylistImgUrl(playlistImg, playlistFirstVideoImg) {
      return _.isEqual(playlistImg, playlistFirstVideoImg)
    },
    async handlePlaylistCoverImg(playlistData) {
      const playlistImg = this.playlist_data.image_url
      const playlistFirstVideoImg = playlistData.length
        ? playlistData[0].video.thumbnail_url
        : ''
      const isEqual = this.checkPlaylistImgUrl(
        playlistImg,
        playlistFirstVideoImg
      )
      if (!isEqual) {
        await this.updatePlaylistCoverImg(playlistFirstVideoImg)
      }
    },
    async updatePlaylistCoverImg(img) {
      try {
        const { data } = await playlistApi.updatePlaylist(
          { image_url: img },
          this.playlist_data.id
        )
        this.UPDATE_PLAYLIST({ ...data })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
